import { ESTADO_MAS_INFORMACION } from './utils';

export const getActions = (estadoId, craftedBy) => {
    const actions = {
        actions: [],
        extra: [],
    };

    if (estadoId === 1) {
        actions.actions.push({
            label: 'Responder solicitud',
            icon: 'edit',
            action: 'responder',
        });
        actions.actions.push({
            label: 'Sin alternativa',
            icon: 'issue',
            action: 'sin_alternativa',
        });
    } else {
        actions.actions.push({
            label: 'Ver detalle',
            icon: 'details',
            action: 'detalle',
        });
    }

    if (estadoId === ESTADO_MAS_INFORMACION) {
        actions.actions.push({
            label: 'Aportar información',
            icon: 'edit',
            action: 'aportar_informacion',
        });
    }
    actions.actions.push({
        label: hasAtClienteAssigned(craftedBy)
            ? 'Cambiar at.cliente'
            : 'Asignar at.cliente',
        icon: 'user',
        action: 'asignar',
    });

    actions.actions.push({
        label: 'Añadir nota interna',
        icon: 'comment',
        action: 'nota_interna',
    });

    actions.actions.push({
        label: 'Borrar solicitud',
        icon: 'delete',
        action: 'delete',
    });

    return actions;
};

export const hasAtClienteAssigned = (craftedBy) =>
    Boolean(craftedBy?.id ?? craftedBy);

export const getAtClienteUserId = (craftedBy) => {
    if (!craftedBy) {
        return null;
    }
    return typeof craftedBy === 'object' ? craftedBy.id : craftedBy;
};

export const getAsignarAtClienteModalTitle = (craftedBy) =>
    hasAtClienteAssigned(craftedBy)
        ? 'Cambiar responsable de atención al cliente'
        : 'Asignar persona de Atención al Cliente';
